import { ROUBLE_SIGN } from '../../constants/symbols';
import { EChartType } from '../../types/charts';

export function getPriceUnit(chartType: EChartType) {
  switch (chartType) {
    case EChartType.Price:
      return ROUBLE_SIGN;
    case EChartType.Sales:
      return 'кв.';
  }
}
